import * as React from "react";

const UserIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={className}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_2899_19258)"
    >
      <path d="M8 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8M2 13.5C3.21 11.408 5.41 10 8 10s4.79 1.408 6 3.5"></path>
    </g>
    <defs>
      <clipPath id="clip0_2899_19258">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default UserIcon;
